import { createAsyncThunk } from '@reduxjs/toolkit';
import familyFestApi from '@infrastructure/family-fest-api';
import { fetchChartsStart, fetchChartsSuccess, fetchChartsFailure } from './familyFestDashboardChartsSlice';
export const fetchFamilyFestDashboardCharts = createAsyncThunk('familyFestDashboardCharts/fetch', async (eventId, { dispatch }) => {
    try {
        dispatch(fetchChartsStart());
        const response = await familyFestApi.getFamilyFestDashboardCharts(eventId);
        dispatch(fetchChartsSuccess(response.data));
        return response.data;
    }
    catch (error) {
        const message = error instanceof Error ? error.message : 'Failed to fetch dashboard charts';
        dispatch(fetchChartsFailure(message));
        throw error;
    }
});
